import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import EditField from '../Forms/EditField';

const propTypes = {
  handleBlur: PropTypes.func,
  handleChange: PropTypes.func,
  name: PropTypes.string,
  signature: PropTypes.string,
  date: PropTypes.string,
};

const CodeOfEthics = ({ handleBlur, handleChange, name, signature, date }) => (
  <Fragment>
    <h4>
      Counselors certified by Sage Financial Solutions
      <sup>®</sup> pledge to maintain the following ethical standards:
    </h4>
    <ul>
      <li>
        Conduct myself in a credible manner, striving for excellence in providing services with competency, diligence,
        promptness and care to the best of my ability.
      </li>
      <li>
        Grow in professional practices by keeping abreast of industry developments and striving to improve my
        professional competency through continuing education.
      </li>
      <li>Exhibit personal and professional honesty and integrity in advising and counseling clients.</li>
      <li>Recognize my limitations and refer clients when appropriate.</li>
      <li>
        Maintain high standards of ethical conduct according to the objectives of the institution with which I am
        affiliated.
      </li>
      <li>
        Respect the privacy of clients and the confidentially of the client-counselor relationship in all matters
        pertaining to the course of professional service, revealing client information of any kind to others only with
        the expressed, informed consent of the client.
      </li>
      <li>
        Accept compensation that is fair and reasonable, and assist clients in finding other services if my fees are not
        affordable.
      </li>
      <li>
        Avoid any act or omission that violates the relevant criminal laws of any State of the United States or of any
        province, territory, or jurisdiction of any other country
      </li>
      <li>
        Report any felony related to the practice of the profession or which brings disrepute to the profession or any
        lesser crime which involves misrepresentation, fraud, extortion, misappropriation or theft or any conspiracy to
        commit such a crime to the Sage Financial Solutions
        <sup>®</sup> Executive Board.
      </li>
      <li>Report any professional suspension by a governmental or industry self-regulatory authority of a license.</li>
      <li>
        Make no false or misleading statements to the Executive Board of Sage Financial Solutions
        <sup>®</sup>, its Certification Council or its Professional Review Board.
      </li>
      <li>
        Respond in a timely fashion to all requests of the Executive Board of Sage Financial Solutions
        <sup>®</sup>, its Certification Council or its Professional Review Board.
      </li>
    </ul>
    <h4>
      I subscribe to the Sage Financial Solutions
      <sup>®</sup> Counselor's Code of Ethics.
    </h4>
    <EditField
      name="codeOfEthicsName"
      label="Please print name"
      value={name}
      onBlur={handleBlur}
      onChange={handleChange}
    />
    <EditField
      name="codeOfEthicsSignature"
      label="Signature"
      value={signature}
      onBlur={handleBlur}
      onChange={handleChange}
    />
    <EditField
      type="date"
      name="codeOfEthicsSignatureDate"
      label="Date"
      value={date}
      onBlur={handleBlur}
      onChange={handleChange}
    />
  </Fragment>
);

CodeOfEthics.propTypes = propTypes;

export default CodeOfEthics;
